<template>
  <v-app>
    <template v-if="showLayout">
      <v-app-bar
          app
          elevation="1"
          :color="backgroundColor"
          height="64"
          clipped-left
      >
        <Header @toggle-drawer="drawer = !drawer"/>
      </v-app-bar>

      <v-navigation-drawer
          v-if="isLoggedIn"
          v-model="drawer"
          app
          clipped
          :color="backgroundColor"
      >
        <SideBar/>
      </v-navigation-drawer>

      <v-main :style="{ background: mainBackground }">
        <v-container
            fluid
            :class="{'pa-6': showLayout}"
        >
          <RouterView/>
          <vue-snotify/>
        </v-container>
      </v-main>

      <Footer/>
    </template>

    <template v-else>
      <RouterView/>
      <vue-snotify/>
    </template>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex'
import SideBar from "@/components/layout/SideBar"
import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"

export default {
  name: 'App',
  components: {
    Footer,
    Header,
    SideBar
  },
  data: () => ({
    drawer: null
  }),
  computed: {
    backgroundColor() {
      return '#FFFFFF'
    },
    mainBackground() {
      return '#F5F7FA'
    },
    ...mapGetters(['isLogged']),
    isLoggedIn() {
      return this.isLogged
    },
    showLayout() {
      return this.$route.meta.layout !== false
    }
  }
}
</script>

<style>
.v-application {
  background-color: var(--v-background-base) !important;
}

.v-list-item--active {
  background-color: var(--v-background-lighten1) !important;
}
</style>